import { store } from '@/store/store';

const STT_STATUS = {
  ENABLE: 'ENABLE',
  DISABLE: 'DISABLE'
};

const getDefaultState = () => {
  return {
    sttList: [],
    status: STT_STATUS.ENABLE
  };
};

const state = getDefaultState();

const getters = {
  sttList: (state) => {
    return state.sttList.filter((data) => data.callKey === store.getters.callKey);
  }
};

const mutations = {
  initSTTList(state, payload) {
    state.status = STT_STATUS.ENABLE;
    // 3자 통화 전환 이벤트 있는 경우엔 바로 비활성 상태로 변경
    if (payload.find((v) => v.event === 'three-way-start')) {
      state.status = STT_STATUS.DISABLE;
      const findIndex = payload.findIndex((item) => item.event === 'three-way-start');
      // 그리고 3자 통화 전환 이벤트 시점 이후의 데이터는 미노출 처리 (서버에서 메세지 전송하지 않기로 했지만, 프론트에서 방어코드)
      if (findIndex + 1 < payload.length) {
        state.sttList = payload.splice(findIndex);
      } else {
        state.sttList = payload;
      }
    } else {
      state.sttList = payload;
    }
  },
  updateSTTList(state, payload) {
    if (state.status !== STT_STATUS.DISABLE) {
      // 3자 통화 전환 이벤트 들어온 경우 해당 케이스까지만 업데이트 하기 위해 비활성 상태로 변경
      if (payload.event === 'three-way-start') {
        state.status = STT_STATUS.DISABLE;
      }
      state.sttList = [...state.sttList, payload];
    }
  },
  CLEAR_STT(state) {
    state.status = STT_STATUS.ENABLE;
    Object.assign(state, getDefaultState());
  }
};

const actions = {};

export default {
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/STT/index.js